<template>
  <div class="flag_manage" >
    <el-row :span="24" style="margin-bottom: 5px;">
      <div class="top_hint">
        <span class="count">欢迎您使用 企业火管理后台，您所在的部门 <span style="color: red">{{ branch }}</span>，您已经入职 <span style="color: red">{{ daysBoard }}</span> 天</span>。
      </div>
    </el-row>
    <div style="margin-top: 0.1rem;margin-bottom: 0.1rem;">
      <ul class="i-content">
        <li v-for="(item, index) in noticeData" :key="index"><index-content :dataOrigin="item"/></li>
      </ul>
      <div style="clear: both;"></div>
    </div>
    <el-tabs type="border-card" style="margin-top: 0.2rem;">
      <el-tab-pane v-for="p in panelOptions" :key="p.id">
        <span
          style="
            display: inline-block;
            text-align: center;
            width: 2rem;
            height: 0.75rem;
          "
          slot="label"
          @click="loadPanelData(p.id)"
          >{{ p.category_name }}</span
        >
        <el-divider content-position="left">{{ p.category_name }}</el-divider>
        <el-table
          max-height="500"
          :data="panelData"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="title" label="标题">
            <template slot-scope="scope">
              <el-link
                type="primary"
                style="font-size: 0.28rem"
                @click="readRecord(scope.row)"
                >{{ scope.row.title }}</el-link
              >
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="录入时间">
          </el-table-column>
          <el-table-column prop="ope_name" label="录入人"> </el-table-column>
          <el-table-column prop="desc" label="概述"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="编辑"
                placement="top"
                v-if="scope.row.ep"
              >
                <a :href="scope.row.body" target="_blank">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    circle
                  >
                  </el-button>
                </a>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>






    <!-- 考核目标（日） 开始 -->
    <el-dialog :visible.sync="checkDialog" :before-close="closeCheckSettingDialog" class="el_dialogs" width="70%">
      <div class="box_title" style="margin-bottom: 0.2rem;">
        <el-row style="position: relative;">
          
          <!-- <el-col :span="6" v-if="checkCircle === 4">
            <span style="font-size: 20px"
              >&nbsp;&nbsp;目标设置（年）：{{ date }}</span
            >
          </el-col>
          <el-col :span="7" v-else-if="checkCircle === 3">
            <span style="font-size: 20px"
              >&nbsp;&nbsp;目标设置（月）：{{ date }}</span
            >
          </el-col>
          <el-col :span="10" v-else-if="checkCircle === 2">
            <span style="font-size: 20px"
              >&nbsp;&nbsp;目标设置（周）：{{ date }}</span
            >
          </el-col> -->
          <el-col :span="7">
            <span style="font-size: 20px"
              >&nbsp;&nbsp;目标设置（日）：{{ date }}</span
            >
          </el-col>
          <el-col :span="2">
            <el-button style="position: absolute;bottom: -.1rem;" size="mini" round type="danger" icon="el-icon-switch-button" @click="logout">退出系统</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table border :data="checkGoal" tooltip-effect="dark" style="width: 95%;margin: .5rem">
          <el-table-column label="考核名称" width="80">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.check_setting.check_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="基础目标" width="80">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.check_setting.check_goal + scope.row.check_setting.check_unit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设置目标值" width="80" :render-header="downOrderrenderHeader">
            <template slot-scope="scope">
              <el-input :min="0" :formatter="formatValue" type="number" v-model="goalValue[scope.row.check_setting.id]" clearable></el-input>
            </template>
          </el-table-column>
        </el-table>

        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div style="color: red;margin-left: .5rem;">注：* 以上目标请全部正确填写！</div>
          <el-button style="margin-right: .5rem;" size="mini" type="primary" @click="settingGoal">保存</el-button>
        </div>

      </div>
    </el-dialog>
    <!-- 考核目标（日） 结束 -->

    <!-- 昨日目标统计 -->
    <el-dialog :visible.sync="yesterdayDialog" :before-close="closeYesterdayDialog" class="el_dialogs" width="70%">
      <div class="box_title" style="margin-bottom: 0.2rem;">
        <el-row style="position: relative;">
          <el-col :span="7">
            <span style="font-size: 20px;margin-left: 20px;"
              >{{ mondayFlag === 1 ? '上周五目标' : '昨日目标' }}：{{ yesterDate }}</span
            >
          </el-col>
          <el-col :span="2">
            <el-button style="position: absolute;bottom: -.1rem;" size="mini" round type="danger" icon="el-icon-switch-button" @click="logout">退出系统</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table border :data="yesterdayCheckGoal" tooltip-effect="dark" style="width: 95%;margin: .5rem">
          <el-table-column label="考核名称" width="80">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.check_setting.check_name }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="mondayFlag === 1 ? '上周五目标 / 完成' : '昨日目标 / 完成'" width="80">
            <template slot-scope="scope">
              <span :style="scope.row.finished_value < scope.row.goal_value ? 'color:red' : ''" class="count-style">{{ scope.row.goal_value }} / {{ scope.row.finished_value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="未达标原因简述" width="150">
            <template slot-scope="scope">
              <el-input :disabled="scope.row.finished_value > scope.row.goal_value ? true : false" v-model="reason[scope.row.id]" type="text" ></el-input>
            </template>
          </el-table-column>
        </el-table>

        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div style="color: red;margin-left: .5rem;">注：* 以上目标请全部正确填写！</div>
          <el-button style="margin-right: .5rem;" size="mini" type="primary" @click="settingYesterDayReason">保存</el-button>
        </div>

      </div>
    </el-dialog>

  </div>
</template>

<script src="./static/call/call-client.umd.js" data-init="true"></script>
<script>
import IndexContent from './IndexContent'

export default {
  name: 'flag_manage',
  components: { IndexContent },
  data () {
    return {
      noticeData: [],
      daysBoard: '',
      branch: '',
      date: '',
      panelData: [],
      panelOptions: [],

      checkDialog: false,  // 日目标弹窗
      checkGoal: [],
      goalValue: [],
      personnel: [],
      totalCheckNum: 0,
      hasSettingGoal: 0,

      checkCircle: 1,
      mondayFlag: 0,
      reason: [],
      yesterdayDialog: false,
      yesterdayCheckGoal: [],
      yesterDate: ''

    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {},
  methods: {
    // 考核目标
    alertPersonTargetSetting () {
      this.getCurrentUserCheckContent(this.checkCircle)
    },
    getCurrentUserCheckContent () {
      this.$axios.post('api/admin/get_user_check_goal', { 
          checkCircle: this.checkCircle
        }).then(({data}) => {
          if (data.code === 0) {
            this.date = data.date
            this.checkGoal = data.data     // 目标数据
            if (this.checkGoal.length > 0) {
              this.checkDialog = true
            }
          }
      }).catch()
    },
    getYesterdayCheckGoal() {
      this.$axios.post('/api/admin/check/get_yesterday_goal')
      .then(res => {
        const { data } = res
        if (data.code === 0) {
          this.yesterdayCheckGoal = data.data
          this.yesterDate = data.yesterDate
          this.mondayFlag = data.mondayFlag
          if (this.yesterdayCheckGoal.length > 0) {
            this.yesterdayDialog = true
          }
        } else {
          console.log(data.msg)
        }
      })
    },
    settingGoal() {
      this.$axios
        .post('/api/admin/check/setting_goal', { goal: this.goalValue, checkCircle: this.checkCircle })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.goalValue = []
            this.checkDialog = false
            this.$message.success(data.msg)

          } else {
            this.$message.error(data.msg)
          }
        })
    },
    settingYesterDayReason() {
      this.$axios.post('/api/admin/check/set_yesterday_goal', {reason: this.reason})
      .then(res => {
        const { data } = res
        if (data.code === 0) {
          this.yesterdayDialog = false
          this.$message.success(data.msg)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    closeCheckSettingDialog (done) {
      // 是否已设置目标
      this.$axios.post('/api/admin/check/check_has_setting', { checkCircle: this.checkCircle })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$confirm('确定要关闭吗？')
              .then(_ => {
                setTimeout(() => {
                  // if (this.checkCircle > 0) {
                  //   this.checkDialog = false
                  //   this.checkCircle--
                  //   this.getCurrentUserCheckContent()
                  // } else {
                  this.checkDialog = false
                  // }
                  done()
                })
              })
              .catch(_ => {})
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    closeYesterdayDialog() {},

    handleASearch() {
      this.getCurrentUserCheckContent()
    },
    loadNotice () {
      this.$axios.get('api/index/get_notice').then(({data}) => {
        if (data.code === 1) {
          this.noticeData = data.data
        }
      }).catch()
    },
    loadPanelData (id) {
      this.panelData = []
      this.$axios
        .get('api/cloudbody/autoshow', {
          params: {
            id: id,
            page: 1,
            perpage: 30
          }
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.panelData = data.data
          }
        })
        .catch()
    },
    getFirst () {
      this.$axios.get('api/cloudbody/autoshow_first').then(({data}) => {
        if (data.code === 1) {
          this.loadPanelData(data.data)
        }
      }).catch()
    },
    loadPanel () {
      this.$axios
        .get('api/cloudbody/catepanel')
        .then(({ data }) => {
          if (data.code === 1) {
            this.panelOptions = data.data
          }
        })
        .catch()
    },
    readRecord (row) {
      sessionStorage.removeItem('feiUrl')
      let newPage = this.$router.resolve({
        path: `/documentation`
      })
      sessionStorage.setItem('feiUrl', row.body)
      window.open(newPage.href, '_blank')
        this.$axios
          .post('api/cloudbody/readrecord', {
            id: row.id,
            title: row.title
          })
          .then(({ data }) => {
            if (data.code === 1) {
            }
          })
          .catch()
    },
    userDayFranch () {
      this.$axios
        .get('api/user/userinfo', {
          params: {
            page: 1,
            perpage: 10
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.daysBoard = data.data.daysBoard
            this.branch = data.data.branch
          }
        })
        .catch()
    },
    formatValue (value) {
      if (value <= 0) {
        return 0;
      }
      return value;
    },
    downOrderrenderHeader (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              content: (function () {
                return '目标值不可以小于基础目标'
              })(),
              placement: 'top'
            }
          },
          [
            h('span', {
              class: {
                'el-icon-question': true
              }
            })
          ]
        )
      ]
    },
    logout () {
      localStorage.removeItem('token')
      location.href = '/login'
    },
  },
  mounted () {
    this.getFirst()
    this.userDayFranch()
    this.loadNotice()
    this.loadPanel()

    const today = new Date().getDay()
    if (today === 6 || today === 0) {
      this.checkDialog = false  // 周末不弹
    } else {
      // 其他情况显示弹窗
      // this.alertPersonTargetSetting()
    }
  }
}
</script>
<style>
.is-selected {
  color: #1989fa;
}
</style>
<style scoped lang="stylus">
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';
@import '~styles/icon.styl';

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-drawer__wrapper >>> .el-drawer__header span {
  color: #5789F4;
  font-size: 0.36rem;
  font-weight: 400;
}

.flag_manage {
  overflow-x: auto;
  marginLeft();

  .count_style {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.m-tabs-content {
  overflow-y: auto;
  padding: 0 0.4rem;
  box-sizing: border-box;

  .m-label {
    line-height: 0.64rem;
  }

  .text_right {
    text-align: left;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }
}

.flag_manage >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

/* .clues_manage >>> .el-table__header thead .is-hidden */
/* color: red */
/* background-color: #ECF4FF */
/* font-size 16px */
.mb-10 {
  margin-bottom: 0.2rem;
  margin-top: 0.4rem;
}

.mt-10 {
  margin-top: 0.2rem;
}

.level {
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 0.32rem;

  img {
    width: 0.32rem;
    height: 0.3rem;
  }

  .el-icon-question {
    margin-left: 0.1rem;
    color: #409EFF;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
}

.el-select, .el-cascader {
  width: 100%;
}

.count {
  padding-left: 0.2rem;
  line-height: 0.56rem;
}

.el-position {
  position: relative;

  .dot {
    display: inline-block;
    width: 0.1rem;
    height: 0.1rem;
    border-radius: 50%;
    margin-right: 0.1rem;
    position: absolute;
    top: 0;
    left: -0.2rem;
    bottom: 0;
    margin: auto;
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.changeHeight {
  padding: 0.2rem;
  margin-top: 0.4rem;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.el-collapse >>> .el-collapse-item__content {
  padding-bottom: 0;
}

.el_dialogs >>> .el-dialog__body {
  padding-left: 0;
  padding-right: 0;
}

.el_dialogs >>> .el-dialog__header {
  padding: 0;
}

.block {
  height: 6rem;
  overflow-y: auto;
  padding-top: 0.2rem;
  padding-left: 0.2rem;
  box-sizing: border-box;

  .time_right {
    width: 100%;
    margin-top: 0.4rem;
    overflow: hidden;
    word-break: break-all;
    white-space: normal;
  }
}

.el-timeline-item__node--large {
  width: 0.4rem;
  height: 0.4rem;
}

/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 0.1rem; /* 竖向滚动条的宽度 */
  height: 10px; /* 横向滚动条的高度 */
}

::-webkit-scrollbar-thumb { /* 滚动条里面的小方块 */
  background: #cdcdcd;
  border-radius: 5px;
}

::-webkit-scrollbar-track { /* 滚动条轨道的样式 */
  background: #f8f8f8;
  border-radius: 5px;
}

.el-date-editor {
  width: 100% !important;
}

.top_hint {
  height: 0.8rem;
  line-height: 0.8rem;
  background: #ECF4FF;

  span {
    color: #5787FF;
  }
}
.i-content li {
  float: left;
  margin-right: 5px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/Index.vue